import React from 'react';

const humanizePart = (part) => part.replace(/([a-z0-9])([A-Z])/g, '$1 $2').replace(/^./, c => c.toUpperCase());

const gainColor = (v) => v > 0 ? '#16a34a' : v < 0 ? 'var(--c-error)' : undefined;

const RecTable = ({ title, items }) => (
  <div style={{ marginBottom: 14 }}>
    <div style={{ fontSize: 12, fontWeight: 700, color: 'var(--c-text-muted)', marginBottom: 6 }}>{title}</div>
    {!items || items.length === 0 ? (
      <div style={{ fontSize: 12, color: 'var(--c-text-light)' }}>No changes needed.</div>
    ) : (
      <table className="fb-table fb-table-sm">
        <thead><tr><th>Part</th><th>Action</th><th>Level</th><th>Wear</th><th>Gain/lap</th><th>Gain/race</th></tr></thead>
        <tbody>
          {items.map(it => (
            <tr key={it.part}>
              <td style={{ fontWeight: 600 }}>{humanizePart(it.part)}</td>
              <td style={{ fontSize: 11 }}>{it.mechanism === 'buyNew' ? 'Buy new' : 'Adjust'}</td>
              <td>{it.currentLevel} → {it.recommendedLevel ?? '—'}</td>
              <td>{it.recommendedLevel != null ? `${it.resultingWearPercent}%` : <span style={{ color: 'var(--c-error)' }}>can't fit ≤100%</span>}</td>
              <td style={{ color: gainColor(it.gainSecPerLap) }}>{it.gainSecPerLap?.toFixed(3)}s</td>
              <td style={{ color: gainColor(it.gainSecPerRace) }}>{it.gainSecPerRace?.toFixed(3)}s</td>
            </tr>
          ))}
        </tbody>
      </table>
    )}
  </div>
);

const WearRecommendationsModal = ({ columnLabel, limited, extreme, onClose }) => (
  <div style={{
    position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)',
    display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 20,
  }} onClick={onClose}>
    <div style={{
      background: '#fff', borderRadius: 'var(--radius-lg)',
      padding: 24, width: 620, maxWidth: '95vw', maxHeight: '85vh', overflowY: 'auto',
      boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
    }} onClick={e => e.stopPropagation()}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 4 }}>
        <div style={{ fontWeight: 700, fontSize: 15 }}>Wear Recommendations — {columnLabel}</div>
        <button onClick={onClose} style={{
          padding: '6px 14px', borderRadius: 'var(--radius-sm)',
          background: '#f9fafb', border: '1px solid var(--c-border)',
          color: 'var(--c-text-muted)', cursor: 'pointer', fontSize: 13,
        }}>Close</button>
      </div>
      <div style={{ fontSize: 11, color: 'var(--c-text-light)', marginBottom: 14 }}>
        Keeps every changed part ≤100% wear at finish, prefers adjusting the part's level over buying new,
        and maximizes speed for the parts it's allowed to touch.
      </div>

      <RecTable title="Limited — only parts currently over 100%" items={limited} />
      <RecTable title="Extreme — any part may be changed" items={extreme} />
    </div>
  </div>
);

export default WearRecommendationsModal;
